import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Toaster, toast } from "sonner";
import { API } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Introduce email y contraseña");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Error al iniciar sesión";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#101421' }}>
      <Toaster position="top-center" richColors theme="dark" />
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="IA Sanitaria" className="h-16 w-auto mx-auto mb-6" />
          <h1 className="text-2xl font-bold text-white mb-2">Panel de Administración</h1>
          <p className="text-gray-500 text-sm">Acceso restringido. Introduce tus credenciales.</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#1A1F2E] border border-gray-700/50 rounded-2xl p-6 space-y-5">
          <div>
            <label className="text-gray-400 text-sm mb-1.5 block">Email</label>
            <Input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="admin@iasanitaria.es"
              className="bg-gray-800 border-gray-700 text-white"
              required
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="text-gray-400 text-sm mb-1.5 block">Contraseña</label>
            <Input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              className="bg-gray-800 border-gray-700 text-white"
              required
              data-testid="login-password"
            />
          </div>
          <Button type="submit" className="btn-primary w-full py-3" disabled={loading} data-testid="login-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
            Acceder
          </Button>
        </form>

        <p className="text-center text-gray-600 text-xs mt-6">
          <a href="/" className="hover:text-gray-400 transition-colors">Volver a la web</a>
        </p>
      </div>
    </div>
  );
}
